const enum ChallengeStatusEnum {
    SUBMITTED = 3,
    FAILED = 2,
    PASSED = 1,
    PENDING = 0
}

export default ChallengeStatusEnum;